// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import hiTranslation from './locales/hi/translation.json';
import pnTranslation from './locales/pn/translation.json';

i18n
  // Detects user language (from localStorage, browser, etc.)
  .use(LanguageDetector)
  // Passes i18n instance to react-i18next
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      hi: { translation: hiTranslation },
      pn: { translation: pnTranslation },

    },
    fallbackLng: 'en', // Default language if detection fails
    debug: false, // Set true for debugging in development

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // Saves user language preference
    },

    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;
